import React from 'react';
import { Collapsible } from './collapsible';

export interface AboutThisPageProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
}

/** Page guidance uses the same disclosure anatomy as optional sections. */
export function AboutThisPage({
  label = 'About this page',
  children,
  className,
}: AboutThisPageProps) {
  return (
    <Collapsible
      label={label}
      className={className}
      triggerClassName="text-body text-text-muted"
      contentClassName="space-y-4 font-body text-body text-text-muted"
    >
      {children}
    </Collapsible>
  );
}
